import { Link } from "react-router-dom";
import { ArrowLeft, Boxes, MessagesSquare, ShieldCheck, Sparkles } from "lucide-react";
import Brand from "../components/Brand";
import { useAuth } from "../context/AuthContext";

const FEATURES = [
  {
    icon: Boxes,
    title: "مدیریت اپلیکیشن‌ها",
    text: "همه پروژه‌های تحت مدیریت، یک‌جا و در دسترس.",
  },
  {
    icon: MessagesSquare,
    title: "گفت‌وگو با ایجنت",
    text: "روی هر اپلیکیشن، با ایجنت هوش مصنوعی آن کار کنید.",
  },
  {
    icon: ShieldCheck,
    title: "دسترسی امن",
    text: "ورود کاربران با حساب اختصاصی و رمز عبور شخصی.",
  },
];

export default function Home() {
  const { isAuthenticated } = useAuth();
  const target = isAuthenticated ? "/dashboard" : "/login";

  return (
    <div className="home">
      <header className="home-nav">
        <Brand subtitle="همکاری با هوش مصنوعی" />

        <Link className="btn btn-ghost home-nav-link" to={target}>
          {isAuthenticated ? "داشبورد" : "ورود"}
          <ArrowLeft size={17} strokeWidth={2} aria-hidden="true" />
        </Link>
      </header>

      <main className="home-main">
        <section className="home-card">
          <span className="home-badge">
            <Sparkles size={14} strokeWidth={2} aria-hidden="true" />
            نسخه اولیه
          </span>

          <h1>به سامانه مدیریت ایجنت‌ها خوش آمدید</h1>
          <p>
            از این پنل می‌توانید اپلیکیشن‌های خود را مدیریت کنید و با کمک ایجنت‌های هوش مصنوعی روی
            آن‌ها کار کنید. برای شروع، وارد حساب کاربری خود شوید.
          </p>

          <Link className="btn btn-primary btn-lg" to={target}>
            {isAuthenticated ? "ورود به داشبورد" : "ورود به پنل"}
            <ArrowLeft size={19} strokeWidth={2} aria-hidden="true" />
          </Link>

          <div className="home-features">
            {FEATURES.map((feature) => (
              <div className="home-feature" key={feature.title}>
                <span className="home-feature-icon" aria-hidden="true">
                  <feature.icon size={19} strokeWidth={1.8} />
                </span>
                <strong>{feature.title}</strong>
                <span>{feature.text}</span>
              </div>
            ))}
          </div>
        </section>
      </main>

      <footer className="home-footer">سامانه مدیریت ایجنت‌ها</footer>
    </div>
  );
}
